import * as React from 'react';
import { NameEmailModalController, NameEmailModalControllerProps } from './NameEmailModal.controller';
import { gql } from '@apollo/client';
import { HelpscoutMetadataDocument, useChangeNameEmailMutation } from '../../../models/graphql';

export type NameEmailModalApolloProps = Omit<
  NameEmailModalControllerProps,
  'changeNameEmailMutation' | 'onSubmit' | 'submitted'
> & {
  // ...
};

gql`
  mutation ChangeNameEmail($name: String!, $email: String!, $userId: ID) {
    updateUser(input: { name: $name, email: $email }, userId: $userId) {
      ...UserFields
    }
  }
`;

export const NameEmailModalApollo = (props: NameEmailModalApolloProps): JSX.Element => {
  const [changeNameEmailMutation] = useChangeNameEmailMutation({
    onCompleted: () => {
      props.onClose();
    },
    refetchQueries: [HelpscoutMetadataDocument] // To update helpscout beacon name + email.
  });

  const controllerProps: NameEmailModalControllerProps = {
    ...props,
    changeNameEmailMutation
  };

  return <NameEmailModalController {...controllerProps} />;
};
